import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux"
import { SERVICE_TYPE_PATH } from "../../../../config/paths";
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from "../../../layout/Content";
import ServiceTypeForm from "./ServiceTypeForm";
import { postServiceType } from '../../../../actions/bus/ServiceType';

export const NewServiceType = ({ breadcrumbs, dispatchPostServiceType }) => {
  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };

    dispatchPostServiceType(newFormValues);
  };

  const content = (
    <ServiceTypeForm
      onSubmit={onSubmit}
      initialValues={{}}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Tipo de Servicio"
      subtitle="Crear nuevo tipo de servicio"
      content={content}
    />
  );
};

NewServiceType.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostServiceType: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostServiceType: postServiceType,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Servicio',
      href: SERVICE_TYPE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(mapStateToProps, mapDispatchToProps)(NewServiceType)